import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { NASProductCategory } from '@websky/graphql';
import { useTheme } from '../../../../theme';
import { getNasServiceCardParams } from '../utils';
import WrappedCommonCard from '../CommonCard/WrappedCommonCard';
const EveryPortLounge = ({ segmentId, service }) => {
    const { t } = useTranslation('Checkout');
    const { t: aasT } = useTranslation('ServiceAggregation');
    const theme = useTheme('CheckoutAdditionalService').Business;
    const params = getNasServiceCardParams(NASProductCategory.lounge);
    return (React.createElement(WrappedCommonCard, { segmentId: segmentId, category: NASProductCategory.lounge, header: t(params.title), service: service, description: t(params.description), coverClassName: theme.business_aggregator, icons: params.icons }, aasT('Entrance with boarding ticket')));
};
export default EveryPortLounge;
